import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';

@Injectable()
export class NewsService {

  constructor(private httpClientService: HttpClientService ) { }

  getNewsList(role,page) {
    return this.httpClientService.getMethod({
      url: '/web/nc/queryNcList/'+role+'/'+page,
    })
  }

  getNewsDetail(id) {
    return this.httpClientService.getMethod({
      url: '/web/nc/queryNcById/'+id,
    })
  }

  // 获取疫情新闻列表
  getNewsVirusList(pageindex,keyword){
    return this.httpClientService.getMethod({
      url: `/web/newshot/queryNewsHotList/${pageindex}?keyword=${keyword}`,
    })
  }

  // 获取疫情新闻详情
  getNewsVirusDetail(id){
    return this.httpClientService.getMethod({
      url: `/web/newshot/queryNewsHotById/${id}`,
    })
  }

}



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/service/news.service.ts